import * as yup from 'yup';

const rootConst = 'FORGOT_PASSWORD_SEND_CODE';

export const SEND_CODE = `${rootConst}/SEND_CODE`;

export const schemaMobile = yup.object({
  mobile_number: yup.string().required('Mobile number is required.'),
});

export const schemaEmail = yup.object({
  email: yup.string().required('Email is required.'),
});
